import script from "./EditPicture.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPicture.vue?vue&type=script&setup=true&lang=js"

import "./EditPicture.vue?vue&type=style&index=0&id=f05770a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f05770a6"]])

export default __exports__